<template>
  <v-container>
    <sub-navigation-obchody></sub-navigation-obchody>
    <v-layout row wrap v-if="!me.podrizeny_maklere || me.makler">
      <v-dialog
        v-model="dialogDetail"
        max-width="500px"
        transition="dialog-transition"
        v-if="dialogDetail"
      >
        <v-card class="no__padding">
          <v-card-title class="pa-0" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
            <h2>Pozice spolupracovníků</h2>
          </v-card-title>
          <v-card-text class="pa-0 mt-3" :class="{'pa-2': $vuetify.breakpoint.smAndDown}">
            <v-layout row wrap>
              <v-flex xs12>
                <v-data-table
                  :headers="headers"
                  :items="kariera.podrizeni"
                  class="elevation-0"
                  hide-controls
                >
                  <template v-slot:items="props">
                    <td class="">{{ props.item.pozice }}</td>
                    <td class="">{{ props.item.pocet }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pa-0 mt-3" :class="{'pa-3 mt-0': $vuetify.breakpoint.smAndDown}">
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-3 elevation-0" class="bold" @click="dialogDetail=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-flex xs12 v-if="kariera!=null">
        <!-- <h1 class="h2 mb-30">Pozice</h1> -->
        <div class="account" :class="{'mt-3': $vuetify.breakpoint.smAndDown}">
          <v-layout row wrap align-center>
            <v-flex xs12 md5>
              <v-layout row wrap>
                <v-flex xs6 sm6 class="mb-3" v-if="!me.makler">
                  <p class="grey--text caption mb-1 bold">Vaše pozice:</p>
                  <strong>{{kariera.pozice}}</strong>
                </v-flex>
                <v-flex xs6 sm6 class="mb-3">
                  <p class="grey--text caption mb-1 bold">Struktura - spolupracovníci:</p>
                  <strong>{{kariera.spolupracovnici_pocet}}</strong>
                  <v-btn color="orange" @click="dialogDetail=true" dark small class="elevation-0 bold button-detal__small ma-0 ml-3" v-if="!me.makler"><v-icon>remove_red_eyes</v-icon> Detail</v-btn>
                </v-flex>
                <v-flex xs6 sm6 class="mb-3">
                  <p class="grey--text caption mb-1 bold">Hodnota kreditu:</p>
                  <strong>{{kariera.hodnota_kreditu}} Kč</strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs6 sm6 class="mb-3">
                  <p class="grey--text caption mb-1 bold">Vlastní kredity:</p>
                  <strong>{{kariera.vlastni_kredity | formatDouble}} kr</strong>
                </v-flex>
                <v-flex xs6 sm6 class="mb-3">
                  <p class="grey--text caption mb-1 bold">Kredity ze struktury:</p>
                  <strong>{{kariera.skupinove_kredity | formatDouble}} kr</strong>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="!me.makler">
                <v-flex xs12 class="mb-3">
                  <p class="grey--text caption mb-1 bold">Certifikován:</p>
                  <v-icon class="text-green" style="margin-bottom: 2px;" small v-if="kariera.certifikovan">check_circle_outline</v-icon>
                  <v-icon class="text-red" style="margin-bottom: 2px;" small v-else>highlight_off</v-icon>
                  <strong v-if="kariera.certifikovan" class="ml-2">ANO</strong>
                  <strong v-else class="ml-2">NE</strong>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 md7 v-if="kariera.dalsi_stupen != null && kariera.cislo_pozice < 7 && !me.makler">
              <div class="career-position">
                <h2 class="text-primary mb-2">Následující kariérní stupeň</h2>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <p class="mb-1"><strong>Pozice: {{kariera.dalsi_stupen.pozice}}</strong></p>
                    <p class="mb-1"><strong>Hodnota kreditu: {{kariera.dalsi_stupen.hodnota_kreditu}} Kč</strong></p>
                    <!-- <p class="bold text-gray fs-14 mb-0">Minimální počet kreditů pro dosažení dalšího stupně: 26 000 kr</p> -->
                  </v-flex>
                  <!-- <v-flex xs12 sm6 class="career-position__right">
                    <p class="bold fs-12 mb-1">Chybí spolupracovníků: <span class="career-outline">8</span> na stupni: <span class="career-outline">IV.</span></p>
                  </v-flex> -->
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </div>
        <div class="career-list" v-if="!me.makler">
          <v-layout row wrap align-center>
            <v-flex xs12 sm6>
              <h2 class="mb-1">Kariérní list</h2>
              <!-- TODO doplnit kariéru -->
              <p class="bold mb-0 text-gray">Pro postup na vyšší stupeň kariéry je potřeba:</p>
            </v-flex>
            <v-flex xs12 sm6>
              <p class="text-xs-center text-sm-right mb-0">
                <a href="./Karierni_plan.pdf" target="_blank">
                  <v-btn color="orange" dark class="elevation-0 bold ma-0"><v-icon class="mr-2">save_alt</v-icon>Stáhnout kariérní list</v-btn>
                </a>
              </p>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Base from '../Base'
  export default {
    extends: Base,
    data () {
      return {
        dialogDetail: false,
        loading: false,
        kariera: null,
        headers: [
          { text: 'Kariérní stupeň', value: 'karierni_stupen', sortable: false },
          { text: 'Počet', value: 'pocet', sortable: false }
        ],
        items: [
          {
            karierni_stupen: '3',
            pocet: "2"
          },
          {
            karierni_stupen: '2',
            pocet: "4"
          }
        ]
      }
    },
    computed: {
      me: function() {
        return window.$me;
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      load (f) {
        this.loading = true;
        window.API.get("obchody/kariera").then(function(body) {
          this.kariera = body;
          this.loading = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      }
    }
  }
</script>
